export class Incident {

    incidentId: number;
    incidentName: string;
    incidentTimeInMilli: number;

    constructor(source: Incident) {
        this.incidentId = source.incidentId;
        this.incidentName = source.incidentName;
        this.incidentTimeInMilli = source.incidentTimeInMilli;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/ViewModel/Incident/Incident.ts